module.exports = __webpack_public_path__ + "static/media/TikTok__3.c59d3b6b.mp4";